import React from 'react';
import PropTypes from 'prop-types';
import Table from 'rc-table';
import LoadingPanel from './LoadingPanel';

const setRowClassName = (record, i) => `row-${i % 2 === 0 ? "odd" : "even"}`
const SimpleTable = (props) => (
                <div>
                        {
                                !props.isLoading &&
                                <Table {...props}
                                        rowClassName={setRowClassName}
                                        className = "search-results-table"                                                                          
                                        />
                        }
                        {
                                props.isLoading &&
                                <LoadingPanel/>
                        }
                </div>
        );

export default SimpleTable;